export default __webpack_public_path__ + "static/media/data.53443faf.gif";